import  { useState } from "react";

type SalesPersonsPreviewBioProps = {
  text?: string | null;
  className?: string;
  collapsedLines?: number; 
};

export function SalesPersonsPreviewBio({ text, className, collapsedLines = 1 }: SalesPersonsPreviewBioProps) {
  const [expanded, setExpanded] = useState(false);

  const bio = (text ?? "").trim();
  if (!bio) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      aria-expanded={expanded}
      onClick={() => setExpanded((v) => !v)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") setExpanded((v) => !v);
      }}
      className={[
        "text-secondary",
        "small",
        "m-0",
        "p-0",
        "user-select-none",
        className ?? "",
      ].join(" ")}
      style={{
        cursor: expanded ? "zoom-out" : "zoom-in",
        ...(expanded
          ? {}
          : {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: collapsedLines,
              overflow: "hidden",
            }),
      }}
      title={!expanded ? bio : undefined}
    >
      <i className="bi bi-info-lg me-1"></i>
      {bio}
    </div>
  );
}
